import React, { useEffect, useState } from "react";
import AnimatedSection from "../AnimatedSection";
import api from "../../api";

const BestSellers = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/products", { params: { featured: true } })
      .then((res) => {
        const data = res.data?.data ?? res.data;
        setProducts(Array.isArray(data) ? data.slice(0, 3) : []);
      })
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  const resolveImage = (p) => p.imageUrl || p.image || "";

  if (loading) {
    return (
      <section className="w-full py-16 sm:py-24 bg-white dark:bg-background-dark" id="best-sellers">
        <div className="px-4 md:px-10 lg:px-20 mx-auto max-w-7xl">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {[0, 1, 2].map((i) => (
              <div key={i} className="rounded-xl overflow-hidden shadow-md animate-pulse">
                <div className="aspect-[4/3] bg-gray-200 dark:bg-gray-700" />
                <div className="p-6 space-y-3">
                  <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-2/3" />
                  <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full" />
                  <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/3" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (!products.length) return null;

  return (
    <section
      className="w-full py-16 sm:py-24 bg-white dark:bg-background-dark"
      id="best-sellers"
    >
      <div className="px-4 md:px-10 lg:px-20 mx-auto max-w-7xl">
        <AnimatedSection className="text-center mb-12" delay={0.2}>
          <h2 className="text-[#181411] dark:text-white text-3xl sm:text-4xl font-bold leading-tight tracking-[-0.015em] mb-4">
            Our Best Sellers
          </h2>
          <p className="text-[#181411]/70 dark:text-white/70 text-lg max-w-2xl mx-auto">
            Discover our most popular handmade desserts that customers love.
            Each piece is crafted with premium ingredients and attention to detail.
          </p>
        </AnimatedSection>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <AnimatedSection key={product.id} delay={0.3 + index * 0.1} direction="up">
              <div className="bg-white dark:bg-background-dark/80 rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-shadow">
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={resolveImage(product)}
                    alt={product.name}
                    className="w-full h-full object-cover transition-transform hover:scale-105 duration-500"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-[#181411] dark:text-white mb-2">
                    {product.name}
                  </h3>
                  <p className="text-[#181411]/70 dark:text-white/70 mb-4">
                    {product.description}
                  </p>
                  <div className="flex justify-between items-center">
                    <span className="text-primary font-bold">
                      {Number(product.price).toFixed(2)} TND
                    </span>
                  </div>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BestSellers;
